/**
 * Opengater access-token refresh.
 *
 * Mirrors the panel's `@/auth/refresh` but against Opengater's GlobalAuth and
 * the `og_`-namespaced token store. GlobalAuth's refresh takes the refresh
 * token in a JSON body and returns a fresh
 * `{ access_token, refresh_token }` pair — see the 8005 OpenAPI
 * `POST /auth/jwt/refresh`.
 *
 * Single-flight: concurrent 401s (a page firing several queries at once) share
 * one in-flight refresh so we don't spend the refresh token multiple times.
 */
import { ogServiceBase } from './services';
import { getOgRefreshToken, saveOgTokens, clearOgTokens } from './tokens';
let inflight = null;
export function refreshOgToken() {
    if (inflight)
        return inflight;
    inflight = (async () => {
        try {
            const rt = getOgRefreshToken();
            const base = ogServiceBase('auth');
            if (!rt || !base)
                return null;
            const res = await fetch(`${base}/auth/jwt/refresh`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh_token: rt }),
            });
            if (!res.ok) {
                clearOgTokens();
                return null;
            }
            const data = (await res.json());
            if (data.access_token) {
                saveOgTokens(data.access_token, data.refresh_token ?? rt);
                return data.access_token;
            }
            clearOgTokens();
            return null;
        }
        catch (e) {
            console.error('refreshOgToken failed', e);
            clearOgTokens();
            return null;
        }
        finally {
            inflight = null;
        }
    })();
    return inflight;
}
